// Mock data for Web Key Studio portfolio

export const portfolioData = {
  // Hero section data
  hero: {
    title: "Web Key Studio",
    subtitle: "Créateur Digital Freelance",
    description: "Sites web sur-mesure, logos percutants, SEO optimisé. Je transforme vos idées en solutions digitales qui marquent les esprits.",
    cta: "Me contacter",
    signature: "by Mike"
  },

  // About section data
  about: {
    title: "À propos",
    subtitle: "Développeur Web Freelance",
    description: "Passionné par la création digitale, je vous accompagne dans la réalisation de vos projets web. De la conception à la mise en ligne, je vous offre un service personnalisé et des solutions techniques adaptées à vos besoins.",
    skills: [
      "Développement web",
      "Création de logos",
      "SEO & référencement",
      "Accompagnement projet"
    ],
    experience: "5+ années d'expérience",
    projects: "25+ projets réalisés"
  },

  // Projects/Realizations data
  projects: [
    {
      id: 1,
      title: "TFFA Pompes Funèbres",
      description: "Site web professionnel avec formulaire de devis, blog informatif et design sobre. Accompagnement des familles selon les traditions islamiques avec humanité et respect.",
      image: "https://customer-assets.emergentagent.com/job_digital-studio-pro/artifacts/imw975t2_Capture%20d%E2%80%99e%CC%81cran%202025-08-21%20a%CC%80%2012.17.36.png",
      technologies: ["Angular 19", "Symfony 7", "MySQL", "Docker"],
      url: "https://www.tffa.fr",
      category: "Site vitrine"
    },
    {
      id: 2,
      title: "Bella Transport",
      description: "Site de déménagement avec formulaire de devis en ligne, avis clients connectés à Google Business. Votre partenaire de transport au quotidien pour déménagement, mise en carton et débarras.",
      image: "https://customer-assets.emergentagent.com/job_digital-studio-pro/artifacts/75qt0rst_Capture%20d%E2%80%99e%CC%81cran%202025-08-21%20a%CC%80%2012.17.10.png",
      technologies: ["WordPress", "Elementor", "Astra Theme", "Google Business"],
      url: "https://bellatransport.fr",
      category: "Site e-commerce"
    },
    {
      id: 3,
      title: "Quickline VTC",
      description: "Plateforme de réservation VTC moderne avec géolocalisation, tarification automatique et suivi en temps réel. Interface intuitive pour chauffeurs et passagers.",
      image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      technologies: ["React", "Node.js", "MongoDB", "Maps API"],
      url: "#", // Remplacez par l'URL réelle
      category: "Application web"
    }
  ],

  // Services data
  services: [
    {
      id: 1,
      title: "Sites WordPress",
      description: "Création de sites WordPress personnalisés avec thèmes sur-mesure et plugins optimisés.",
      icon: "Globe"
    },
    {
      id: 2,
      title: "Sites Angular/Symfony",
      description: "Développement d'applications web modernes avec Angular et API Symfony.",
      icon: "Code"
    },
    {
      id: 3,
      title: "Création de Logos",
      description: "Design d'identités visuelles uniques et mémorables pour votre marque.",
      icon: "Palette"
    },
    {
      id: 4,
      title: "Fiches Produits Shopify",
      description: "Optimisation et création de fiches produits attractives pour votre boutique.",
      icon: "ShoppingCart"
    },
    {
      id: 5,
      title: "SEO Basique",
      description: "Optimisation du référencement naturel pour améliorer votre visibilité.",
      icon: "TrendingUp"
    },
    {
      id: 6,
      title: "Conseils Hébergement",
      description: "Accompagnement dans le choix de solutions d'hébergement adaptées.",
      icon: "Server"
    }
  ],

  // Testimonials data - Vrais avis Google
  testimonials: [
    {
      id: 1,
      name: "Slimane Bellahcene",
      company: "Bella Transport",
      text: "Je suis passé par Web key studio pour la création d'un site internet Bella transport. Rien à dire, Mike a été très efficace et professionnel. Le respect du délai et du cahier des charges a été exemplaire. Je recommande à 100%.",
      rating: 5,
      source: "Google"
    },
    {
      id: 2,
      name: "Amber Halim",
      company: "Client Web Key Studio",
      text: "Nous avons collaboré avec Web Key Studio pour la création de notre site internet et notre communication globale, et nous sommes ravis des résultats ! Mike a fait preuve de professionnalisme et d'écoute, transformant notre vision en un site esthétique et fonctionnel. Sa stratégie de communication a vraiment boosté notre visibilité. Un grand merci 😊",
      rating: 5,
      source: "Google"
    },
    {
      id: 3,
      name: "Sabrina Momix",
      company: "Client Web Key Studio",
      text: "J'ai fait appel à Web Key Studio pour la création de mon site et je suis vraiment ravie du résultat ! Mike a été super rapide, efficace et très professionnel. Il a parfaitement compris mes besoins et a livré un site moderne et fonctionnel en un temps record. Je recommande à 100% !",
      rating: 5,
      source: "Google"
    }
  ],

  // Contact data
  contact: {
    title: "Me contacter",
    subtitle: "Prêt à donner vie à votre projet ?",
    description: "Discutons ensemble de vos besoins et trouvons la solution digitale qui vous correspond.",
    phone: "0646802549",
    social: {
      instagram: "@webkey_studio",
      snapchat: "@webkeystudio"
    },
    form: {
      fields: ["name", "email", "message"],
      submitText: "Envoyer le message"
    }
  }
};

export default portfolioData;